<template>
  <div>
    <p>{{lang[0]}}</p>
    <div class="message-wrapper">
      <div id="scrollArea">
        <div v-if="messagesData.length > 0">
          <div v-for="(val, key, index) in messagesData">
            <div v-if="val.send_user.id == $store.state.account.id" class="my-message">
              <div class="my-message-content">
              <div class=text-wrapper>
                <p v-if="val.mention_user">@{{val.mention_user.name}}</p>
                <p>{{val.text}}</p>
              </div>
            </div>
            <div class="user">
              <div class="icon" v-if="val.send_user.icon_img" :style="`background-image: url(${val.send_user.icon_img})`"></div>
              <div class="icon" v-else :style="`background-image: url(${val.send_user.icon_img}`"></div>
              <p class="user-name">{{ val.send_user.screen_name }}</p>
            </div>
          </div>
          <div v-else class="other-message">
            <div class="user">
              <div class="icon" v-if="val.send_user.icon_img" :style="`background-image: url(${val.send_user.icon_img})`"></div>
              <div class="icon" v-else :style="`background-image: url(${val.send_user.icon_img}`"></div>
              <p class="user-name">{{ val.send_user.screen_name }} <i class="reply fa fa-reply" @click="mention(val.send_user)"></i></p>
            </div>
            <div class="other-message-content">
              <!-- <div class=other-text-wrapper v-if="val.type === 0">
                <p >{{type_val[0][val.content_type]}}</p>
              </div>
              <img v-else-if="val.type === 1" :src="type_val[1][val.content_type]"class="message-img"> -->
              <div class=other-text-wrapper>
                <p v-if="val.mention_user">@{{val.mention_user.name}}</p>
                <p>{{val.text}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="other-message">
          <div class="user">
            <div class="icon nazuna"></div>
            <p class="user-name">{{lang[1]}}</p>
          </div>
          <div class="other-message-content">
            <div class=other-text-wrapper>
              <p>{{lang[2]}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="input-area" v-if="this.$store.state.auth.authenticated">
    <div class=input-wrapper>
      <textarea v-model="message" class="text-select" :placeholder="lang[3]"></textarea>
    </div>
    <div class="post-wrapper">
      <p v-if="reply" class="mention-label">To: {{reply}} <i class="fa fa-close" @click="deleteMention"></i></p>
      <btn class="post-btn" type="primary" size="normal" :label="lang[4]" @click="post()" :loading="loading"></btn>
    </div>
  </div>
</div>
</div>
</template>

<script>
import Btn from '../components/Button.vue'
import axios from 'axios'
import MesseageLangMaster from '../masters/langMaster/MesseageLangMaster'
import langCheck from '../mixins/langCheck.js'

export default {
name: 'Message',

components:{
  Btn,
  axios
},

data(){
  return {
    lang: '',
    noAuthLang: '',
    messagesData: {},
    type: 0 ,
    message: '',
    loading: false,
    content_type: 2,
    mention_id: null,
    type_val: [
      [
        "",
      ],
      [
        "",
      ]
    ],
    reply: "",
  }
},

props:[
  'requestData',
  'itemData'
],

mixins: [langCheck],

mounted() {
  this.loadMessage()
  this.langCheck(MesseageLangMaster)
},

methods: {
  loadMessage() {
    let getId = this.requestData ? this.requestData.id : this.itemData.id
    let scrollArea = document.getElementById('scrollArea')
    let scrollbuttom = 0
    axios.get(`public/message/${getId}`)
    .then((data) => {
      this.messagesData = data.data.model
      this.$nextTick(() => {
        scrollbuttom = scrollArea.scrollHeight
        scrollArea.scroll(0,scrollbuttom)
      })
    }) .catch((err) => {
      console.log(err);
    });
  },

  mention(val) {
    this.mention_id = val.id
    this.reply = val.screen_name
  },

  post(val) {
    if(this.content_type==2 && this.message=='') {
      return false
    }
    this.loading = true
    if(this.$store.state.account.id !== this.requestData.buyer_id && this.mention_id === null) {
      this.mention_id = this.requestData.buyer_id
    }
    axios.post('private/message/', {
      request_id: this.requestData.id,
      item_id: this.itemData ? this.itemData.id : null,
      mention_id: this.mention_id,
      send_id: this.$store.state.account.id,
      type: this.type,
      content_type: val ? val : this.content_type,
      text: this.message,
    }).then(data => {
      this.loadMessage()
      this.loading = false
      this.message = ''
      this.reply = null
      this.mention_id = null
    }).catch(err => {
      console.log(err)
    })
  },

  deleteMention() {
    this.mention_id = null
    this.reply = null
  }
 }

}

</script>

<style scoped>

.message-wrapper{
   margin: 5px;
}

.my-message {
  padding: 5px;
  display: flex;
  margin: 10px 0;
  justify-content: flex-end;
}

.other-message {
  padding: 5px;
  margin: 10px 0;
  display: flex;
  justify-content:start;
}

#scrollArea{
  max-height:300px;
  height: auto;
  overflow-y: scroll;
  background: #ffff;
  border: 1px solid #ccc;
  border-radius: 10px;
}

.text-wrapper{
  background: #91B5F2;
  border-radius: 5px;
  margin: 0 !important;
  white-space:pre-line;
  word-break:normal;
}

.text-wrapper p {
  margin: 0 !important;
  padding: 5px;
}

.icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #F39939;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url('../assets/img/def-user.png');
}

.nazuna {
  background-image: url('../assets/img/nazuna-reverse.png');
  background-position: -22px 3px;
  background-size: 100px;
}

.user-name {
  font-size: 12px;
}

.input-wrapper{
  display: flex;
  justify-content: center;
}

.my-message-content {
  border-radius: 5%;
  margin-right: 1%;
}

.my-message-content p{
  color: #ffffff;
  margin-left: 10px;
  word-break: break-all;
}

.other-text-wrapper{
  background: #f5f5f5;
  border-radius: 5px;
  margin-left: 10px;
}

.other-text-wrapper p {
  margin: 0 !important;
  padding: 5px;
}

.other-message-content{
  border-radius: 5%;
  margin-right: 2%;
}

.other-message-content p{
  margin-left: 10px;
  word-break: break-all;
}

.input-area {
  margin-top: 10px;
  margin-bottom: 10px;
}

.input-area textarea{
  width:100%;
  height:100px;
  resize: none;
  align:center;
  border-radius: 10px 10px 0 0;
  padding: 10px;
}

.type-select {
  width: 90%;
  display: block;
}

.template-select {
  width: 90%;
  display: block;
  margin: 10px 0;
}

.stamp-select {
  width: 90%;
  height: 200px;
  overflow-y: scroll;
  margin: 10px 0;
}

.stamp-select img {
  width: 100px;
}

.text-select {
  width: 90%;
  border: 1px solid #dcdcdc;
  margin: 10px 0 0 0;
}

.message-img {
  width: 150px;
  display: block;
  margin: 0 auto;
}

.post-wrapper {
  border-bottom: 1px solid #dcdcdc;
  border-right: 1px solid #dcdcdc;
  border-left: 1px solid #dcdcdc;
  padding: 5px;
  position: relative;
  height: 52px;
  border-radius: 0 0 10px 10px;
}


.reply {
  margin-left: 5px;
  color: #5a5a5a;
}

.post-btn {
  position: absolute;
  right: 5px;
}

.mention-label {
  background: #f5f5f5;
  padding: 5px;
  position: absolute;
  left: 5px;
}

.user {
  width: 50px;
  margin: 0 5px;
}

@media screen and (min-width: 800px){
  .my-message {
    margin: auto;
  }

  #scrollArea{
    max-height: 500px;
    padding: 10px;
  }
}
</style>
